var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C3.89474 10 3 10.8947 3 12C3 13.1053 3.89474 14 5 14C6.10526 14 7 13.1053 7 12C7 10.8947 6.10526 10 5 10ZM5 4C3.89474 4 3 4.89474 3 6C3 7.10526 3.89474 8 5 8C6.10526 8 7 7.10526 7 6C7 4.89474 6.10526 4 5 4ZM5 16C3.89474 16 3 16.8947 3 18C3 19.1053 3.89474 20 5 20C6.10526 20 7 19.1053 7 18C7 16.8947 6.10526 16 5 16ZM20 11H10C9.45614 11 9 11.4561 9 12C9 12.5439 9.45614 13 10 13H20C20.5439 13 21 12.5439 21 12C21 11.4561 20.5439 11 20 11ZM20 5H10C9.45614 5 9 5.45614 9 6C9 6.54386 9.45614 7 10 7H20C20.5439 7 21 6.54386 21 6C21 5.45614 20.5439 5 20 5ZM20 17H10C9.45614 17 9 17.4561 9 18C9 18.5439 9.45614 19 10 19H20C20.5439 19 21 18.5439 21 18C21 17.4561 20.5439 17 20 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListOutlined);
export default __webpack_public_path__ + "static/media/list_outlined.72571f6f.svg";
export { ForwardRef as ReactComponent };